<template>
  <v-tabs
    grow
    color="grey darken-4"
    slider-color="cyan lighten-2"
    class="user-actions_navigation"
  >
    <!-- <v-tab to="/login" class="white--text">
      Sign in
    </v-tab>
    <v-tab to="/registration" class="white--text">
      Sign up
    </v-tab> -->
  </v-tabs>
</template>

<script>
export default {
  name: "UserActionsNavigation"
};
</script>

<style scoped>
.user-actions_navigation {
  position: fixed;
  bottom: 70px;
  left: 0;
  width: 100%;
}
</style>
